export default __webpack_public_path__ + "static/media/CV.56ef4d3f.pdf";